<template>
  <div class="hidden lg:block h-full bg-transparent">
    <div
        class="slide relative"
        ref="allSlides"
        v-for="(url, index) in urls"
        :key="index"
    >
      <img :src="url" alt="Photo {{ index }}"/>
      <h1 class="heading--1">{{ texts[index] }}</h1>
      <div class="flex flex-row">
        <div class="slider__btn slider__btn--left absolute"></div>
        <div class="dots__dot" @click="dotsClickEvent"></div>
        <div
            class="slider__btn slider__btn--right absolute"
            @click="nextSlide"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import { assetUrl } from "@/common/constants";

export default {
  name: "photo__content",
  data() {
    return {
      urls: [assetUrl('assets/img/SliderImages/fb_app_small.webp')],
      currSlide: 0,
      doInterval: null,
      texts: [
        "Gobernación del Tolima",
        "Secretaria de Hacienda - Tesoreria",
      ],
    };
  },
  methods: {
    activeDot(slide) {
      document
          .querySelectorAll(".dots__dot")
          .forEach((dot) => dot.classList.remove("dots__dot--active"));
      document
          .querySelector(`.dots__dot[data-slide="${slide}"]`)
          .classList.add("dots__dot--active");
    },
    goToSlide(slide) {
      this.$refs.allSlides.forEach((s, i) => {
        s.style.transform = `translateX(${100 * (i - slide)}%)`;
      });
    },
    nextSlide() {
      if (this.currSlide === this.urls.length - 1) {
        this.currSlide = 0;
      } else {
        this.currSlide++;
      }
      this.goToSlide(this.currSlide);
      this.activeDot(this.currSlide);
    },
    createDots() {
      //Dots
      const dotsContainer = document.querySelector('.dots__dot');

      this.$refs.allSlides.forEach((_, i) => {
        dotsContainer.insertAdjacentHTML(
            "beforeend",
            `<button class="dots__dot" data-slide="${i}"></button>`
        );
      });
    },
    dotsClickEvent(e) {
      if (e.target.classList.contains("dots__dot")) {
        const {slide} = e.target.dataset;
        this.goToSlide(slide);
        this.activeDot(slide);
      }
    },
    init() {
      this.goToSlide(this.currSlide);
      this.createDots();
      this.activeDot(this.currSlide);
    },

    slider() {
      this.init();
      this.doInterval = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },
  },
  mounted() {
    this.slider();
  },
  unmounted() {
    clearInterval(this.doInterval);
  }
};
</script>
<style lang="scss">
@import "@/style/main.scss";

.slide {
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  transition: transform 1s;
}

.slide > img {
  max-width: 70%;
  max-height: 70%;
  object-fit: contain;
}

.slider__btn--left {
  left: 6%;
  transform: translate(-50%, -50%);
}

.slider__btn--right {
  right: 6%;
  transform: translate(50%, -50%);
}

.heading--1 {
  font-size: 2rem;
  color: #000000;
}

.dots {
  position: absolute;
  bottom: 5%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
}

.dots__dot {
  background-color: transparent;
  @include customBorder(transparent, $color__gray--light);

  opacity: 0.7;
  height: 1rem;
  width: 1rem;
  border-radius: 50%;
  margin-right: 1.75rem;
  cursor: pointer;
  transition: all 0.5s;
}

.dots__dot:last-child {
  margin: 0;
}

.dots__dot--active {
  background-color: $color__gray--light;
  opacity: 1;
}
</style>
